import { useEffect } from "react";

import { CHORUS_DO_NOT_TRACK_COOKIE } from "@framework/config/app.config";
import { useAuth } from "@voxmedia/duet-context/context/auth-context";
import { useConfigContext } from "@voxmedia/duet-context/context/config-context";
import { getCookie } from "@voxmedia/duet-utils/cookie";
import {
  getParselyUUID,
  trainParselyProfile,
} from "@voxmedia/duet-utils/parsely";

const useParselyTraining = ({ enabled = true }: { enabled: boolean }) => {
  const { communityDomain } = useConfigContext().communityConfig;
  const auth = useAuth();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    // Wait until auth has initialized to see if we can use a Google ID
    if (auth.userLoading) {
      return;
    }

    const uuid =
      getParselyUUID(auth.user?.uid || auth.viewer?.id.toString() || null) ||
      "";
    const url = new URL(window.location.toString());

    // Train Parsely with real URLs because dev and preview URLs (e.g.,
    // localhost) do not seem to work for training purposes.
    if (url.host !== communityDomain) {
      url.host = communityDomain;
      url.port = "";
      url.protocol = "https:";
    }

    // TODO: (cvle) figure out if we can watch for a different cookie (gtm) to do this?
    // respect chorus do-not-track
    if (getCookie(CHORUS_DO_NOT_TRACK_COOKIE)) {
      return;
    }

    void trainParselyProfile(communityDomain, uuid, url.toString());
  }, [communityDomain, enabled, auth, auth.userLoading]);
};

export default useParselyTraining;
